// extracted by mini-css-extract-plugin
module.exports = {"colon":"Colon_colon__1AS1d"};